function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { chakra, useStyles } from '@chakra-ui/system';
import React from 'react';
import { CaretDownIcon } from '../icons';
export var PageSelect = _ref => {
  var {
    options,
    selectProps,
    containerProps,
    hideIcon
  } = _ref;
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(chakra.div, _extends({}, containerProps, {
    __css: styles.select
  }), /*#__PURE__*/React.createElement(chakra.select, selectProps, options.map(OPT => /*#__PURE__*/React.createElement("option", {
    key: OPT.value,
    value: OPT.value
  }, OPT.label))), !hideIcon && /*#__PURE__*/React.createElement(CaretDownIcon, null));
};
//# sourceMappingURL=page-select.js.map